function addFields(event) {
    const targetTableId = this.getAttribute("data-target");  // Data-target shows concert or rehearsal
    const table = document.getElementById(targetTableId);

    const elementsWithClass = table.querySelectorAll(`.${targetTableId}`); // All elements with concert or rehearsal class
    const elementsArray = Array.from(elementsWithClass); // Needed to find last 2 elements

    const last = elementsArray.slice(-1)[0];
    const penultimate = elementsArray.slice(-2)[0];

    // First check if both are filled
    if (last.value === "" || penultimate.value === "") {
        alert("Zarówno nazwa, jak i wartość muszą być wypełnione przed dodaniem nowego progu.");
        return; // Don't add new row if previous is not filled correctly
    }

    // here we have to find last item_counter from an appropriate table
    const name = last.name;
    const regex = /(\d+)$/;
    const match = name.match(regex);
    const number = parseInt(match[1], 10);
    const newNumber = number + 1;

    // Create new row
    const newRow = document.createElement("tr");
    newRow.id = `newrow${newNumber}`;

    // Create category input
    const categoryCell = document.createElement("td");
    const categorySelect = document.createElement("select");
    const selectName = `${targetTableId}_${newNumber}`;
    categorySelect.name = selectName;
    categorySelect.classList.add(targetTableId);
    categorySelect.classList.add("form-control");
    categorySelect.classList.add("form-control-sm");
    const option1 = document.createElement("option");
    option1.value = "present";
    option1.text = "Obecny";
    const option2 = document.createElement("option");
    option2.value = "absent";
    option2.text = "Nieobecny";
    categorySelect.appendChild(option1);
    categorySelect.appendChild(option2);
    categoryCell.appendChild(categorySelect);

    // Create name input
    const nameCell = document.createElement("td");
    const nameInput = document.createElement("input");
    nameInput.type = "text";
    const nameName = `${targetTableId}_${newNumber}`;
    nameInput.name = nameName;
    nameInput.classList.add(targetTableId);
    nameInput.classList.add("form-control");
    nameInput.classList.add("form-control-sm");
    nameInput.placeholder = "Nazwa";
    nameInput.maxLength = 50;
    nameCell.appendChild(nameInput);

    // Create weight input
    const numberCell = document.createElement("td");
    const numberInput = document.createElement("input");
    numberInput.type = "number";
    numberInput.step = "0.1";
    const weightName = `${targetTableId}_${newNumber}`;
    numberInput.name = weightName;
    numberInput.classList.add(targetTableId);
    numberInput.classList.add("form-control");
    numberInput.classList.add("form-control-sm");
    numberInput.placeholder = "Waga";
    numberCell.appendChild(numberInput);


    // Create delete button

    const removeIcon = document.createElement("i");
    removeIcon.classList.add("remove", "mdi", "mdi-close-circle-outline");
    removeIcon.title = "usuń";
    removeIcon.setAttribute("data-rowid", `newrow${newNumber}`);
    const deleteCell = document.createElement("td");
    deleteCell.appendChild(removeIcon);


    // Adding cells to row
    newRow.appendChild(categoryCell);
    newRow.appendChild(nameCell);
    newRow.appendChild(numberCell);
    newRow.appendChild(deleteCell);

    // adding row to table
    table.appendChild(newRow);

}

window.document.addEventListener("DOMContentLoaded", function () {

    var invitationDivs = document.querySelectorAll(".add-threshold-button");

    invitationDivs.forEach(function (button) {
        button.addEventListener("click", addFields);
    });
});



document.addEventListener("click", function (event) {
    if (event.target.classList.contains("remove")) {
        const rowId = event.target.getAttribute("data-rowid");
        const rowToRemove = document.getElementById(rowId);
        if (rowToRemove) {
            rowToRemove.remove();
        }
    }
});


document.addEventListener("DOMContentLoaded", function () {

    const submitButton = document.querySelector('.confirm-new-thresholds');
    if(!submitButton){
        return;
    }
    submitButton.addEventListener("click", function (event) {
        event.preventDefault();

        const checkbox = document.querySelector('.edit_thresholds');
        const form = document.querySelector('form');

        if (checkbox.checked) {
            form.submit();

        } else {

            //  Here we check whether there are some checks made today
            const ensembleSlug = this.getAttribute("data-ensemble-slug");

            const url = `/api/event/${ensembleSlug}/check-list/something-checked-today`;

            const xhr = new XMLHttpRequest();
            var csrftoken = $.cookie('csrftoken'); // Get CSRFToken from cookie

            xhr.open("POST", url, true);
            xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            xhr.setRequestHeader('X-CSRFToken', csrftoken);

            xhr.onreadystatechange = function() {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        // Django response
                        const response = JSON.parse(xhr.responseText);
                        if (response.areChecks) {

                            const confirmed = confirm('Nowy zestaw progów będzie obowiązywał od dziś. Masz już częściowo sprawdzone wydarzenie w tym dniu. Kontynuując spowodujesz usunięcie wszystkich sprawdzeń w dzisiejszych wydarzeniach!');
                            if (confirmed) {
                                // User clicked "ok" - form is going to be sent
                                form.submit();

                            } else {
                                // User canceled his request - we do nothing
                            }

                        } else {
        //                    There are no checks, so we can set new thresholds with no conflicts
                            form.submit();
                        }

                    } else {
                        alert('Nie udało się ustawić nowych progów');
                    }
                }
            };

            // Sending POST
            xhr.send();
        };
    });
//    };
});
